
import React, { useState } from "react";
import { renderField } from "./RenderField";
import { getFileUrl } from "../api/fileService.js";
import "../styles/main.css";

function PopupModal({ mode, record, config, onClose, onSave, onModeChange }) {
  const [formData, setFormData] = useState(record || {});
  const [isSaving, setIsSaving] = useState(false);
  const isView = mode === "view";
  const title = mode === "create" ? "New Record" : mode === "update" ? "Edit Record" : "Record Details";

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAdd = (name) => {
    const newItem = { displayText: "", url: "" };
    setFormData((prev) => ({
      ...prev,
      [name]: [...(prev[name] || []), newItem],
    }));
  };

  const handleRemove = (name, index) => {
    const updatedList = [...(formData[name] || [])];
    const item = updatedList[index];

    if (name === "savedFiles" && item.url) {
      // Mark for deletion and update displayText, but do NOT remove from list
      updatedList[index] = {
        ...item,
        _markedForDeletion: true, 
        displayText: `(To be deleted) ${item.displayText || "Unnamed file"}`
      };
    } else {
      // For new file (no urs => never saved in S3 bucket) or other field types: just remove
      updatedList.splice(index, 1);
    }

    setFormData(prev => ({ ...prev, [name]: updatedList }));
  };

  const handleItemChange = (name, index, key, val) => {
    setFormData((prev) => {
      const updated = [...(prev[name] || [])];
      if (!updated[index]) updated[index] = {};
      updated[index][key] = val;
      return { ...prev, [name]: updated };
    });
  };

  const handleViewFile = async (url) => {
    const signedUrl = await getFileUrl(url);
    console.log("PopupModal: Value passed to window.open:", signedUrl) ;
    window.open(signedUrl, "_blank");
  };

  const handleSubmit = async () => {
    if (onSave) {
      setIsSaving(true);
      try {
        await onSave(formData);
        onClose(); // Only close on success
      } catch (err) {
        console.error("PopupModal error:", err);
        alert(err.message || "Failed to save record.");
        setIsSaving(false);
      }
    }
  };

  console.log('PopupModal before return - formData:',formData ) ;

  return (
    <div className="modal-overlay">
      <div className="modal-box scrollable">
        <h2>{title}</h2>
        <form className="form-grid">
          {config.map((field) => (
            <React.Fragment key={field.name}>
              {renderField({
                field,
                value: formData[field.name],
                mode: mode,
                onChange: (val) => handleChange(field.name, val),
                onAdd: () => handleAdd(field.name),
                onRemove: (idx) => handleRemove(field.name, idx),
                onItemChange: (idx, key, val) => handleItemChange(field.name, idx, key, val),
                onViewFile: handleViewFile,
              })}
            </React.Fragment>
          ))}
        </form>
        <div className="modal-actions">
          <button onClick={onClose}>Close</button>
          {!isView && // no Save button needed n View Mode.
            <button disabled={isSaving} onClick={handleSubmit}>
              {isSaving ? "Processing... " : "Save"}
            </button>
          }
          {isView && // Add an Edit button when in View mode
            <button onClick={() => onModeChange("update")}>Edit</button>
          }
        </div>
      </div>
    </div>
  );
}

export default PopupModal;
